var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2026-03-27T12:00:52-fef0efe"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["clashofclans-inbox@supercell"]={id:"2026-03-27T12:00:52-fef0efe"};
      